/**
  * @function evalute - evaluate formCollectionBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const backReferenceIndex = await sourceEvaluator(source.backReferenceIndex);
  if (backReferenceIndex === undefined) {
    return undefined;
  }
  const formTypeIdentifiers = await sourceEvaluator(source.formTypeIdentifiers);
  if (formTypeIdentifiers === undefined) {
    return undefined;
  }
  const sort = (await sourceEvaluator(source.sort)) || [{
    index: 'title',
    ascending: true
  }];
  const {
    id
  } = content;
  if (!id) return undefined;
  const filters = {
    [backReferenceIndex]: [[id]]
  };
  const querySource = {
    type: 'queryFormBehavior',
    formTypeIdentifiers,
    sort,
    filters,
    indexes: ['title'] // workaround for https://app.clickup.com/t/86dtuvecf
  };
  const forms = await sourceEvaluator(querySource);
  if (forms === undefined) {
    return undefined;
  }
  const collection = {};
  for (let i = 0; i < forms.length; i += 1) {
    const {
      id: remoteID
    } = forms[i];
    collection[remoteID] = {
      _formRef: remoteID,
      _created: i
    };
  }
  return collection;
};
module.exports = {
  evaluate
};